import { createStyles } from '@material-ui/styles'
import { ThemeType } from 'theme'

export const nextButtonStyles = (theme: ThemeType) =>
  createStyles({
    btn: {
      position: 'relative',
      zIndex: 4,
      display: 'flex',
      alignContent: 'center',
      height: 24,
      borderRadius: 32,
      paddingTop: 14,
      paddingBottom: 14,
      paddingLeft: 12,
      paddingRight: 42,
      textTransform: 'lowercase',
      fontWeight: 700,
      color: theme.palette.white(1),
      transition: 'all 0.45s ease-out, fontWeight 0.2s 0.4s linear',
      boxShadow: '0px 3px 6px rgba(0,0,0,0.16)',

      '&:hover img': {
        opacity: 1,
      },
      '&:hover': {
        paddingTop: 14,
        paddingBottom: 14,
        paddingLeft: 26,
        paddingRight: 55,
        fontWeight: 900,
        transition: 'padding 0.3s ease-out, fontWeight 0.1s linear',
      },
    },
    'btn-icon': {
      opacity: 0,
      width: 20,
      marginRight: 12,
    },
  })
